export const POST_CODE_UPDATED = "POST_CODE_UPDATED";
export const FETCH_PRICES_STARTED = "FETCH_PRICES_STARTED";
export const FETCH_PRICES_SUCCESS = "FETCH_PRICES_SUCCESS";
export const FETCH_PRICES_FAILURE = "FETCH_PRICES_FAILURE";
export const UNIT_OF_MEASURE_UPDATED = "UNIT_OF_MEASURE_UPDATED";
export const PRICE_DETAILS_UPDATED = "PRICE_DETAILS_UPDATED";
export const GST_TYPE_TOGGLED = "GST_TYPE_TOGGLED";
export const PRICE_TYPE_TOGGLED = "PRICE_TYPE_TOGGLED";
export const WISHLIST_TOGGLED = "WISHLIST_TOGGLED";
export const QUANTITY_DECREMENTED = "QUANTITY_DECREMENTED";
export const QUANTITY_INCREMENTED = "QUANTITY_INCREMENTED";
export const QUANTITY_UPDATED = "QUANTITY_UPDATED";
export const FETCH_STOCK_STARTED = "FETCH_STOCK_STARTED";
export const FETCH_STOCK_SUCCESS = "FETCH_STOCK_SUCCESS";
export const FETCH_STOCK_FAILURE = "FETCH_STOCK_FAILURE";
export const STOCK_DETAILS_UPDATED = "STOCK_DETAILS_UPDATED";
export const FETCH_BRANCH_STOCK_STARTED = "FETCH_BRANCH_STOCK_STARTED";
export const FETCH_BRANCH_STOCK_SUCCESS = "FETCH_BRANCH_STOCK_SUCCESS";
export const FETCH_BRANCH_STOCK_FAILURE = "FETCH_BRANCH_STOCK_FAILURE";
export const FETCH_SUBURB = "FETCH_SUBURB";
export const FETCH_CLEARANCE_PRICE_STARTED = "CLEARANCE_PRICE_STARTED";
export const FETCH_CLEARANCE_PRICE_SUCCESS = "CLEARANCE_PRICE_SUCCESS";
export const FETCH_CLEARANCE_PRICE_FAILED = "CLEARANCE_PRICE_FAILED";
export const BRANCH_SELECTED = "BRANCH_SELECTED";